<template>
	<div class="plus_d " style="">
		<Tou></Tou>
		<el-breadcrumb class="w1500 pt-30" separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
			<el-breadcrumb-item :to="{ path: '/plus_details' }">plus_detail</el-breadcrumb-item>
			<el-breadcrumb-item>collect_points</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="w1500 rel detail_nr br-10 mt-30 bj-0 pt-100 pb-45 mb-190" style="">
			<div class="tit-36  B-500 montserMedium collectformtitle" style="width:100%;text-align: center ;color:#333333;">Collect your GoodWe PLUS+ points!</div>
			<div class="tit-18 pt-10 collectformtitle2"style="width:100%;text-align: center;color:#a3a5a4">
					Please select model type and enter SN of your inverter or battery. 
				</div>
			<div class="tit-18 pt-10 collectformtitle2"style="width:100%;text-align: center;color:#a3a5a4">You can find your SN(18 digits) on your device label or purchase invoice.</div>
			<div class="tit-18 pt-10 collectformtitle2"style="width:100%;text-align: center;color:#a3a5a4">Click “Add” to claim more than one device, or download template to claim in batch!</div>
			<!-- <div class="tit-18  collectformtitle3" style="width:100%;text-align: center;color:#a3a5a4">for Energy Storage Combo(Battery + Inverter)!</div> -->
			<div class="mt-65 collectformbox mb-147" >
				<el-form class="collectform" ref="form" :model="postshu" label-width="0">
					<el-form-item label="" required class="">
						<div class="battery-group-container">
							<div v-for="(l,i) in postshu.snlie" class="battery-input-row" style="position: relative;">
								<div class="collect_points-a4 ">
									<div class="tit-16 pl-25" style="color: #333333;width: auto;">Model Type <span style="color: #FF0005;">*</span></div>
									<!-- 逆变器自动完成：加载状态+核心回调 -->
									<el-autocomplete 
										:fetch-suggestions="qiuqiumodeltype" 
										size="medium" 
										class="PostFrominput" 
										v-model="l.modelType"
										placeholder-class="tit-16"
										:loading="modelTypeLoading"
									></el-autocomplete>
								</div>
								<div class="collect_points-a4 ">
									<div class="tit-16 pl-25" style="color: #333333;width:auto;">SN<span style="color: #FF0005;">*</span></div>
									<el-input  
										@blur="sendsn(l.sn)" 
										size="medium" 
										class="PostFrominput" 
										v-model="l.sn"
										placeholder-class="tit-16" 
										maxlength="80" 
										minlength="10"
									></el-input>
								</div>
								<div class="delBatteryType el-icon-error tit-28" v-if="i>0" @click="delget2(i)"></div>
								<div style="border-top: 1px dashed #AEAEAE;margin: 20px 0;" class=" pb-17"></div>
							</div>
							<div class="addBatteryType">
								<div @click="addget2" class="add-btn el-icon-plus tit-20 b-500" style="color: #6a6a6a;"></div>
								<div class="tit-16 ml-7" style="color: #333333;height: .42rem;line-height: .42rem;">Add</div>
							</div>
						</div>
					</el-form-item>
					<!-- <el-form-item label="" required class="">
						<div class="battery-group-container">
							<div 
								v-for="(l,i) in postshu.batteryList" 
								:key="i" 
								class="battery-input-row"
								:class="{hasdel:i!== 0}"
							>
								<div class="collect_points-a4 mb-17">
									<div class="tit-16 pl-25 PostFrominput2-title" style="color: #333333;">Battery Type (if any)<span style="color: #FF0005;">*</span></div>
									<el-autocomplete 
										:fetch-suggestions="(query, cb) => querySearchAsync(query, cb, i)"
										size="medium" 
										class="PostFrominput PostFrominput2" 
										v-model="l.batteryType"
										@select="handleSelect"	
										placeholder-class="tit-16"
										:loading="batteryLoading[i]"
									></el-autocomplete>
								</div>
								<div class="collect_points-a4">
									<div class="tit-16 pl-25 PostFrominput2-title" style="color: #333333;">Battery SN (if any)<span style="color: #FF0005;">*</span></div>
									<el-input  
										@blur="sendsn2(l,i)" 
										size="medium" 
										class="PostFrominput PostFrominput2" 
										v-model="l.batterySn" 
										placeholder-class="tit-16" 
										
									></el-input>
								</div>
								<div class="delBatteryType el-icon-error tit-28" v-if="i !== 0" @click="delget(i)"></div>
							</div>
							<div class="addBatteryType">
								<div @click="addget" class="add-btn el-icon-plus tit-20 b-500" style="color: #6a6a6a;"></div>
								<div class="tit-16 ml-7" style="color: #333333;height: .42rem;line-height: .42rem;">Add battery</div>
							</div>
						</div>
					</el-form-item> -->
					<div class="flex j-around mt-40 pb-30 ">
						<el-button class="querensong tit-18 ys-0 cur_pointer br-25" @click="tijiao">Submit</el-button>
						<!-- <el-upload class="upload-demo tit-15 ml-21"
						  :show-file-list="true"
						  action="https://community.goodwe.com/api/serialnumber/export"
						  :headers="uploadHeaderss"  
						  :on-success="onSuccess"
						  :on-remove="handleRemove"
						  :file-list="fileList"
						  :limit="1"
						>
						 <el-button slot="trigger"  size="small" icon="el-icon-upload2" class="" style="border-radius: 50px;background: #fff;width: 100px;height:50px ;margin-right:8px;"></el-button>
						</el-upload> -->
						<el-upload 
						  class="upload-demo tit-15"
						  :show-file-list="false"
						  action="https://community.goodwe.com/api/serialnumber/export"
						  :headers="uploadHeaderss"  
						  :on-success="onSuccess"
						  :on-remove="handleRemove"
						  :file-list="fileList"
						  :limit="1"
						  :on-change="handleFileChange" 
						  :on-exceed="handleExceed"     
						>
						  <el-button 
						    slot="trigger"  
						    size="small" 
						    icon="iconfont icon-fabu" 
						    class="" 
						    style="border-radius: 50px;background: #fff;width: 100px;height:50px ;"
						  ></el-button>
						  <div class="tubiaowenzi" style="text-align: center;margin-top:4px;">Upload in xls/xlsx</div>
						</el-upload>
						<div style="align-items: center;">
							<el-button size="small" style="width:100px;height:50px ;border-radius: 50px;" icon="iconfont icon-xiazai" @click="xiazai"></el-button>
							<div class="tubiaowenzi" style="text-align: center;margin-top:4px;">Download template</div>
						</div>
						

					</div>
				</el-form>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import Tou from '../../../zuzuzu/touss.vue'
	import Foot from '../../../zuzuzu/foot.vue'
	import { queryModel, validateSn ,serialnumberuse,querytemplate} from '@/api/colleect.js';
	import { getToken} from '@/utils/auth'
	//   config.headers['X-Token'] = 

	export default {
		data() {
			return {
				postshu: {
					modeltype: '',
					sn: '',
					// 修复：字段名和模板v-model统一（batteryType/batterySn）
					batteryList: [{ batteryType: '', batterySn: '' }],
					ModelTypelist: [], // 逆变器型号下拉数据
					BatteryTypelist: [], // 电池型号下拉数据
					snlie:[{modelType:'',sn:'',error:''}], // 逆变器
				},
				modelTypeLoading: false, // 逆变器请求加载状态
				batteryLoading: [], // 多电池项独立加载状态（数组对应索引）
				yy:'',
				fileList: [],
				 uploadHeaders: {
				  },
				uploadHeaderss: {
					// "Content-Type":'application/json'
				 }
			}
		},
		components: { Tou, Foot },
		watch: {
		    '$store.state.cunyuanyan': {
		      handler(newValue, oldValue) {
		        // console.log('语言已更新:', newValue);
				this.yy=this.$store.state.yuyan
		      },
		      deep: true // 如果 cunyuanyan 是对象，需要设置 deep 为 true
		    }
		},
		created: function () {
			this.$store.commit('Gaiyuyan', this.$store.state.yuyan);
			this.yy=this.$store.state.yuyan
			this.uploadHeaders['Content-Type']='application/json'
			// this.uploadHeaderss['Content-Type']="multipart/form-data"
			this.uploadHeaderss['token']=this.$qu('kouling')
		},
		methods: {
			 // 核心：文件选择/状态变化时清空历史文件
			  handleFileChange(file, fileList) {
			    // 只保留最新选择的文件（清空历史，只留当前）
			    this.fileList = [file];
			  },
			
			  // 超出数量限制时的提示（可选，提升用户体验）
			  handleExceed(files, fileList) {
			    // this.$message.warning(`最多只能上传 1 个文件，请先删除已上传的文件后再选择`);
			    // 强制清空历史，只保留最新选择的那个
			    this.fileList = [files[0]];
			  },
			handleRemove(file, fileList) {
				const indexToRemove = this.wenjianlei.findIndex(item => item.uid === file.uid);
				if (indexToRemove !== -1) {
				  this.wenjianlei.splice(indexToRemove, 1);
				}
			},
			onSuccess(e,file, fileList) {
				if (e.message =='success' && !e.data[0]) {
					this.$message.success(`成功`);
					// that.wenjianlei.push({
					//   data: e.data,
					//   uid: file.uid // el-upload 会为每个文件生成一个唯一的 uid
					// }) 
				}else{
					this.$message.error(e.data[0].error);
				}
			},
			handleRemove(file, fileList) {
				// const indexToRemove = this.wenjianlei.findIndex(item => item.uid === file.uid);
				// if (indexToRemove !== -1) {
				//   this.wenjianlei.splice(indexToRemove, 1);
				// }
			},
			// 新增电池项：初始化加载状态+统一字段名
			addget() {
				this.postshu.batteryList.push({ batteryType: '', batterySn: '' });
				this.$set(this.batteryLoading, this.postshu.batteryList.length - 1, false);
			},
			// 删除电池项：同步删除加载状态
			delget(index) {
				this.postshu.batteryList.splice(index, 1);
				this.batteryLoading.splice(index, 1);
			},
			// 新增逆变项：初始化加载状态+统一字段名
			addget2() {
				this.postshu.snlie.push({ modelType: '', sn: '' ,error:''});
				this.$set(this.batteryLoading, this.postshu.snlie.length - 1, false);
			},
			// 删除逆变项：同步删除加载状态
			delget2(index) {
				this.postshu.snlie.splice(index, 1);
			},
		xiazai() {
		  const loading = this.$loading({ text: '模板下载中...' });
		
		  // 强制设置请求头为 application/json（覆盖拦截器默认值）
		  const requestHeaders = {
		    'Content-Type': 'application/json'
		  };
		
		  // 正确调用：第一个参数是data（空），第二个是配置
		  querytemplate({}, { 
		    headers: requestHeaders,
		    responseType: 'blob' 
		  }).then(res => {
		    loading.close();
		    const rawData = res; // 适配 request.js 返回的是 response.data
		
		    // 校验二进制数据是否有效
		    if (!rawData || (rawData.size === 0 && rawData instanceof Blob)) {
		      this.$message.error('下载失败：模板文件为空');
		      return;
		    }
		
		    // 包装成 Blob（兼容 application/octet-stream 类型）
		    const blob = new Blob([rawData], {
		      type: 'application/octet-stream' // 匹配后端返回的 Content-Type
		    });
		
		    // 执行下载
		    const url = window.URL.createObjectURL(blob);
		    const link = document.createElement('a');
		    link.href = url;
		    link.download = 'earnPoints.xlsx'; // 固定文件名
		    document.body.appendChild(link);
		    link.click();
		
		    // 清理资源
		    setTimeout(() => {
		      document.body.removeChild(link);
		      window.URL.revokeObjectURL(url);
		    }, 500);
		
		    this.$message.success('模板下载成功');
		
		  }).catch(error => {
		    loading.close();
		    this.$message.error(`下载失败：${error.message || '网络异常'}`);
		    console.error('下载详情：', error);
		  });
		},
			
			// 保留你的downloadFile函数（无需修改）
			downloadFile(blobData) {
			  if (!(blobData instanceof Blob)) {
			    console.error('传入的不是 Blob 类型', blobData);
			    return;
			  }
			
			  // 兼容 IE
			  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
			    navigator.msSaveOrOpenBlob(blobData, 'template.xlsx'); // 建议用xlsx后缀
			    return;
			  }
			
			  // 标准方式
			  const url = window.URL.createObjectURL(blobData);
			  const link = document.createElement('a');
			  link.href = url;
			  link.download = 'template.xlsx'; // 三方用的xls，建议改xlsx（更通用）
			  document.body.appendChild(link);
			  link.click();
			  document.body.removeChild(link);
			  window.URL.revokeObjectURL(url);
			},
			// xiazai(){
			// 	querytemplate({ headers:this.uploadHeaders}).then(res=>{
			// 		console.log(res)
			// 		 const uint8Array = new Uint8Array(res.length);
			// 		    for (let i = 0; i < res.length; i++) {
			// 		      uint8Array[i] = res.charCodeAt(i);
			// 		    }
			// 		// 创建 Blob
			// 		const blobData = new Blob([uint8Array], {
			// 		  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			// 		});
			// 		// 调用下载函数
			// 		this.downloadFile(blobData);
			// 	})
			// },
			// downloadFile(blobData) {
			//   if (!(blobData instanceof Blob)) {
			//     console.error('传入的不是 Blob 类型', blobData);
			//     return;
			//   }
			
			//   // 兼容 IE
			//   if (window.navigator && window.navigator.msSaveOrOpenBlob) {
			//     navigator.msSaveOrOpenBlob(blobData, 'template.xlsx');
			//     return;
			//   }
			
			//   // 标准方式
			//   const url = window.URL.createObjectURL(blobData);
			//   const link = document.createElement('a');
			//   link.href = url;
			//   link.download = 'template.xlsx';
			//   document.body.appendChild(link);
			//   link.click();
			//   document.body.removeChild(link);
			//   window.URL.revokeObjectURL(url);
			// },
			/********************* 逆变器Model Type 下拉核心 - 无防抖 *********************/
			qiuqiumodeltype(queryString, cb) {
				// 空值不请求，直接返回空下拉
				if (!queryString) return cb([]);
				this.modelTypeLoading = true;
				queryModel({ model: queryString, type: 1 })
					.then(res => {
						this.postshu.ModelTypelist = res.data || [];
						// 核心：格式化{value: 显示值}，通过cb传给组件渲染下拉
						const result = this.postshu.ModelTypelist.map(item => ({
							value: item.model || item.name || item, // 适配后端任意返回格式
						}));
						cb(result); // 触发下拉显示
					})
					.catch(err => {
						console.error('逆变器型号查询失败：', err);
						cb([]); // 失败也返回空，避免组件报错
					})
					.finally(() => {
						this.modelTypeLoading = false;
					});
			},

			/********************* 电池Battery Type 下拉核心 - 无防抖 *********************/
			querySearchAsync(queryString, cb, index) {
				if (!queryString) return cb([]);
				this.$set(this.batteryLoading, index, true);
				queryModel({ model: queryString, type: 2 })
					.then(res => {
						this.postshu.BatteryTypelist = res.data || [];
						// 核心：同逆变器，格式化后通过cb返回
						const result = this.postshu.BatteryTypelist.map(item => ({
							value: item.model || item.name || item,
						}));
						cb(result); // 触发下拉显示
					})
					.catch(err => {
						console.error(`第${index+1}个电池型号查询失败：`, err);
						cb([]);
					})
					.finally(() => {
						this.$set(this.batteryLoading, index, false);
					});
			},

			/********************* SN校验 *********************/
			sendsn(e) {
				console.log(e)
				if (!e) return; // 空值不请求
				validateSn({ sn:e, type: 1}).then(shu => {
					if(shu.code!=200){
						this.$message({
						  showClose: true,
						  message:shu.message,
						  type: 'error',
						  offset:'150',
						  duration:2000
						});
						this.postshu.sn=''
					}
					
				});
			},
			// 多电池项SN校验：传索引区分
			sendsn2(val,i) {
				validateSn({ sn: val.batterySn, type:2}).then(shu => {
					if(shu.code!=200){
						this.$message({
						  showClose: true,
						  message:shu.message,
						  type: 'error',
						  offset:'150',
						  duration:2000
						});
						 this.postshu.batteryList[i].batterySn=''
					}
				});
			},
			tijiao(){
				console.log(this.postshu)
				let sershu={}
			  const validsnlie = this.postshu.snlie.filter(item => {
				// 去除首尾空格，避免用户输入空格导致的“假非空”
				const modelType = (item.modelType || '').trim();
				const sn = (item.sn || '').trim();
				const error= (item.error || '').trim();
				// 只要有一个字段非空，就保留该条数据
				return modelType!== '' || sn!== '' ||  error!=='';
			  }) || []; // 兜底：如果batteryList本身是undefined，直接设为[]
				sershu.serialNumberList=validsnlie
				// sershu.modelType=this.postshu.modeltype
				// sershu.sn=this.postshu.sn
				serialnumberuse(sershu).then(s=>{
					if(s.code!=200){
						if(s.data){
							this.$message({
							  showClose: true,
							  message:s.data[0].error,
							  type: 'error',
							  offset:'150',
							  duration:2000
							});
						}else{
							this.$message({
							  showClose: true,
							  message:s.message,
							  type: 'error',
							  offset:'150',
							  duration:2000
							});
						}
					}else if(s.code==200){
						this.$message({
						  showClose: true,
						  message:'Successfully earned points',
						  type: 'success',
						  offset:'150',
						  duration:2000
						});
					}
					this.postshu.snlie=[{modelType:'',sn:'',error:''}]
				})
			},
			// 下拉选中事件：获取选中的型号值
			handleSelect(item) {
				console.log('选中的电池型号：', item.value);
				// 后续可加选中后的联动逻辑
			},
		}
	}
</script>

<style lang="scss">
.collect_points-a4 {
		height:61px;
		min-height: 30px;
		width:100%;
		border: 1px solid #D8D8D8;
		border-radius: 5px;
		overflow: hidden;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		.el-input, .el-autocomplete {
			height: 100%;
			// width: 100%;
			.el-input__inner {
				height: 100%;
				border-radius: 5px;
				border: none;
			}
		}
	}
	.icon-xiazai,.icon-fabu{
		font-size:24px;
	}
	.tubiaowenzi{
		font-size:0.1rem;
	}
	.querensong {
		background-image: linear-gradient(4deg, rgb(255, 117, 88) 0%, rgb(230, 0, 18) 100%);
		color: #fff;
		border: 0;
		width: 100px;height:50px
		
	}
	.collectformbox{
		width:6.23rem;margin-left:auto;margin-right:auto;
	}
	.collectform{
		.el-form-item{
				margin-bottom:19px;
				.el-form-item__content{
					line-height: normal;
				}
		}
	}
	.battery-group-container {
		position: relative;
	}
	.battery-input-row {
		margin-bottom: 20px;
		align-items: center;
		position: relative;
		&:hover .delBatteryType {
			opacity: 1;
		}
	}
	// 添加按钮样式
	.addBatteryType{
		position: absolute;
		right: -25%;
		bottom: 9px;
		display: flex;
		align-items: center;
		.add-btn{
			width: .42rem;
			height: .42rem;
			border-radius: 50%;
			background:#F2F2F2;
			line-height: .42rem;
			text-align: center;
			cursor: pointer;
			color: #6a6a6a;
		}
	}
	// 删除按钮：悬浮显示+鼠标手型
	.delBatteryType{
		transition: opacity 0.2s ease;
		position: absolute;
		top: -6px;
		right: -10px;
		color: #ff0004;
		opacity:0;
		cursor: pointer;
	}
	.PostFrominput2{
		width: 68%;
	}
	.PostFrominput2-title{
		width: 32%;
	}
	@media screen and (min-width: 200px) and (max-width: 768px) {
		.collectformtitle{
			font-size: .36rem;
		}
		.collectformtitle2,.collectformtitle3{
			font-size: .18rem;
		}
		.collectformbox{
			width:84%
		}
		.addBatteryType{
			position: unset;
		}
		.PostFrominput2{
			width: 49%;
		}
		.PostFrominput2-title{
			width: 50%;
		}
	}
	@media screen and (min-width: 768px) and (max-width:1024px) {
		.collectformbox{
			width:60%
			
		}
		.PostFrominput2-title{
			width:34%;
		}
		.PostFrominput2{
			width: 66%;
		}
		.add-btn{
			width: 0.62rem !important;
			height: 0.62rem !important;
			line-height: 0.62rem !important;
		}
		.addBatteryType{
			right: -29%;
		}
	}
	@media screen and (min-width:1024px) and (max-width:1366px) {
		.collectformbox{
			width:49%
		}
		.addBatteryType{
			right: -26%;
		}
	}
	@media screen and (min-width:1024px) and (max-width:1256px) {
		.collectformbox{
			width:60%
			
		}
	}
</style>